
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news/[id]",
      function () {
        return require("private-next-pages/news/[id].tsx");
      }
    ]);
  